import { FC, ReactNode } from "react";
// 组件
import CopyText from "../../CopyText";
import RouteLink from "../../RouteLink";
import { ProTooltip } from "../../antd";
// 常量
import { RenderLabelProps } from "../interface";

/** 禁用展示文字 */
const RenderLabel: FC<RenderLabelProps & { text?: ReactNode; }> = props => {
  const { copy, text, isDisabledEllipsis, routeLinkProps, } = props;
  if (typeof text !== 'string') {
    return routeLinkProps ? <RouteLink {...routeLinkProps} /> : <span>{text}</span>;
  }
  const copyText = routeLinkProps ? <RouteLink text={text} {...routeLinkProps} /> : text;
  if (copy) {
    return (
      <CopyText text={text} showText={copyText} showTooltips={isDisabledEllipsis} />
    );
  }
  return isDisabledEllipsis ? (
    <ProTooltip title={text} placement="topLeft">{copyText}</ProTooltip>
  ) : <span>{copyText}</span>;
};

export default RenderLabel;
